/*
 * @Author: luxiao.guo luxiao.guo@gienteck.com
 * @Date: 2022-11-17 18:07:49
 * @LastEditors: luxiao.guo luxiao.guo@gienteck.com
 * @LastEditTime: 2022-11-21 11:02:52
 * @FilePath: /lcds-app/unified-development-platform/src/apis/auth/move-auth/app/organization_api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { request } from '@/apis/request';
const PRE_PATH = '/v1/app';

/**
 * @description: 组织机构管理 —— 给机构分配用户
 * @param {*} orgNo
 * @param {*} appId
 * @param {*} data
 * @return {*}
 */
export function auth_users(appId, orgNo, data) {
  return request({
    url: `${PRE_PATH}/org/assignUser?appId=${appId}&orgNo=${orgNo}`,
    method: 'post',
    data,
    rd: true,
  });
}

/**
 * @description: 组织机构管理 —— 保存或修改
 * @param {*} data
 * @return {*}
 */
export function save_org(data) {
  return request({
    url: `${PRE_PATH}/org/save`,
    method: 'post',
    data,
    rd: true,
  });
}

// /**
//  * @description: 组织机构管理 —— 更新
//  * @param {*} orgNo
//  * @param {*} data
//  * @return {*}
//  */
// export function update_org_by_no(orgNo, data) {
//   return request({
//     url: `${PRE_PATH}/org/${orgNo}`,
//     method: 'post',
//     data,
//     rd: true,
//   });
// }

/**
 * @description: 组织机构管理 —— 删除
 * @param {*} orgNo
 * @param {*} appId
 * @return {*}
 */
export function delete_org_by_no(params) {
  return request({
    url: `${PRE_PATH}/org/delete`,
    method: 'delete',
    params,
    rd: true,
  });
}

/**
 * @description: 组织机构管理 —— 获取机构的用户
 * @param {*} orgNo
 * @param {*} appId
 * @return {*}
 */
export function get_user_of_org(params) {
  return request({
    url: `${PRE_PATH}/org/users`,
    method: 'get',
    params,
    rd: true,
  });
}

// export function check_org_name(orgName, orgNo) {
//     return request({
//         url: `/v1/app/org/orgName?orgName=${orgName}&orgNo=${orgNo}`,
//         method: 'get',
//         rd: true
//     })
// }
export const check_org_name = (orgName, orgNo, appId) => {
  return `/v1/app/org/orgName?orgName=${orgName}&orgNo=${orgNo}&appId=${appId}`;
};

/**
 * @description: 组织机构管理 —— 获取分页列表
 * @param {*} params
 * @return {*}
 */
export function get_orgs(params) {
  return request({
    url: `${PRE_PATH}/org/page`,
    method: 'get',
    params: params,
    rd: true,
  });
}

/**
 * @description: 组织机构管理 —— 获取数
 * @param {*} params
 * @return {*}
 */
export function get_orgs_tree(params) {
  return request({
    url: `${PRE_PATH}/org/all`,
    method: 'get',
    params: params,
    rd: true,
  });
}
/**
 * @description: 组织机构管理 —— 获取扩展字段
 * @return {*}
 */
export const queryOrgExtendFiled = params => {
  return request({
    url: `${PRE_PATH}/org/extendFiled`,
    method: 'post',
    params,
    rd: true,
  });
};

/**
 * @description: 组织机构 —— 获取详情
 * @param {*} appId
 * @param {*} orgNo
 * @return {*}
 */
export const getOrgInfo = params => {
  return request({
    url: `/v1/app/org/detail`,
    method: 'get',
    params,
  });
};
